import { getColorByScore } from "./utils";

interface ScoreCircleProps {
  score?: number;
  size?: number;
  strokeWidth?: number;
  fontSize?: number;
  labelSize?: number;
  labelText?: string;
  titleInsteadScore?: string | number;
  backgroundColor?: string;
  colorText?: string;
  opacity?: number;
  zIndex?: number;
  totalMonthsExperience?: string[] | null;
  isShowExperience?: boolean;
}

export const ScoreColorCircle = ({
  score = 0,
  size = 100,
  strokeWidth = 6,
  fontSize = 20,
  labelSize = 10,
  backgroundColor = "transparent",
  colorText = "#000",
  opacity = 1,
  labelText,
  titleInsteadScore,
  zIndex,
  totalMonthsExperience,
  isShowExperience = false
}: ScoreCircleProps) => {
  const normalized = Math.max(0, Math.min(100, score));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalized / 100) * circumference;

  const color = getColorByScore(normalized);

  const dotRadius = strokeWidth * 0.8;
  const dotBorderWidth = strokeWidth * 0.4;
  const totalDotRadius = dotRadius + dotBorderWidth;

  const svgPadding = totalDotRadius;
  const svgSize = size + svgPadding * 2;
  const center = svgSize / 2;

  const angle = (normalized / 100) * 360 - 90;
  const piAngle = (angle * Math.PI) / 180;
  const circleX = center + radius * Math.cos(piAngle);
  const circleY = center + radius * Math.sin(piAngle);

  const [titleMonth, labelMonth] = totalMonthsExperience?.length ? totalMonthsExperience : ["Нет", "данных"];
  const title = totalMonthsExperience?.length ? titleMonth : titleInsteadScore;
  const label = totalMonthsExperience?.length ? labelMonth : labelText;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: zIndex,
      }}
    >
      <svg
        width={svgSize}
        height={svgSize}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="lightgray"
          strokeWidth={strokeWidth}
          fill={backgroundColor}
          opacity={opacity}
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${center} ${center})`}
          opacity={opacity}
        />
        {normalized > 0 && (
          <>
            <circle
              cx={circleX}
              cy={circleY}
              r={totalDotRadius}
              fill={color}
              opacity={opacity}
            />
            <circle
              cx={circleX}
              cy={circleY}
              r={dotRadius}
              fill="white"
              opacity={opacity}
            />
          </>
        )}
      </svg>
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          color: colorText,
        }}
      >
        <div style={{ fontSize: fontSize, fontWeight: 700, lineHeight: 1 }}>
          {isShowExperience ? title : normalized}
        </div>
        <div style={{ fontSize: labelSize, fontWeight: 500, lineHeight: 1 }}>
          {isShowExperience ? label : "баллов"}
        </div>
      </div>
    </div>
  );
};
